import type { BSETBase, LaborRates, OverTimeAttributes } from '../dtos';

export type LaborField = keyof Pick<BSETBase,
  'projectManagementLabor' | 'engineerLabor' | 'mechanicalEngineerLabor' |
  'electricalEngineerLabor' | 'specialistLabor' | 'networkEngineerLabor' |
  'qualificationEngineerLabor' | 'cyberSecEngineerLabor' | 'energyEngineerLabor' |
  'lengEngineerLabor' | 'graphicsLabor' | 'programmingLabor' | 'digitalDeploymentLabor'>;

export type LaborRateField = { [K in keyof LaborRates]: LaborRates[K] extends number ? K : never }[keyof LaborRates];

export const LABOR_FIELDS: readonly {
  hours: LaborField; standard: LaborRateField;
  overtime: keyof OverTimeAttributes;
  pwr?: LaborRateField;
}[] = [
  { hours: 'projectManagementLabor', standard: 'projectManagementRates', overtime: 'overtimePMRate' },
  { hours: 'engineerLabor', standard: 'engineeringRates', overtime: 'overtimeENGRate' },
  { hours: 'mechanicalEngineerLabor', standard: 'mechanicalRates', overtime: 'overtimeMECHRate', pwr: 'adjMechPWRRate' },
  { hours: 'electricalEngineerLabor', standard: 'electricianRates', overtime: 'overtimeELECRate', pwr: 'adjElecPWRRate' },
  { hours: 'specialistLabor', standard: 'specialistRates', overtime: 'overtimeSPECRate', pwr: 'adjSpecPWRRate' },
  { hours: 'networkEngineerLabor', standard: 'networkEngineeringRates', overtime: 'overtimeNENGRate' },
  { hours: 'qualificationEngineerLabor', standard: 'qualificationEngineeringRates', overtime: 'overtimeQENGRate' },
  { hours: 'cyberSecEngineerLabor', standard: 'cyberSecEngineeringRates', overtime: 'overtimeCENGRate' },
  { hours: 'energyEngineerLabor', standard: 'energyEngineeringRates', overtime: 'overtimeEENGRate' },
  { hours: 'lengEngineerLabor', standard: 'lEngineeringRates', overtime: 'overtimeLENGRate' },
  { hours: 'graphicsLabor', standard: 'graphicsRates', overtime: 'overtimeGrapRate' },
  { hours: 'programmingLabor', standard: 'programmingRates', overtime: 'overtimeProgRate' },
  { hours: 'digitalDeploymentLabor', standard: 'ddsRates', overtime: 'overtimeDdsRate' }
];
